export const environment = {
  production: false,
  enforceHttps: true,
  tenantId:'my00001',
  groupCode:'my00001'
};
